import React from "react";
import { Link, useLocation } from "react-router-dom";
// Trocado ListTree por GitFork
import { LayoutDashboard, Package, ShoppingCart, Users, Settings, Tag, GitFork, Shield, Activity, Mail, Key } from "lucide-react";

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    {
      name: "Dashboard",
      href: "/admin",
      icon: <LayoutDashboard className="h-5 w-5" />,
    },
    {
      name: "Produtos",
      href: "/admin/products",
      icon: <Package className="h-5 w-5" />,
    },
    {
      name: "Categorias",
      href: "/admin/categories",
      icon: <Tag className="h-5 w-5" />,
    },
    {
      name: "Subcategorias",
      href: "/admin/subcategories",
      // Ícone atualizado para GitFork
      icon: <GitFork className="h-5 w-5" />,
    },
    {
      name: "Pedidos",
      href: "/admin/orders",
      icon: <ShoppingCart className="h-5 w-5" />,
    },
    {
      name: "Clientes",
      href: "/admin/customers",
      icon: <Users className="h-5 w-5" />,
    },
    {
      name: "Administradores",
      href: "/admin/admins",
      icon: <Shield className="h-5 w-5" />,
    },
    {
      name: "Registro de Atividades",
      href: "/admin/activity-logs",
      icon: <Activity className="h-5 w-5" />,
    },
    {
      name: "Newsletter",
      href: "/admin/newsletter",
      icon: <Mail className="h-5 w-5" />,
    },
    {
      name: "Alterar Senha",
      href: "/admin/change-password",
      icon: <Key className="h-5 w-5" />,
    },
    {
      name: "Configurações",
      href: "/admin/settings",
      icon: <Settings className="h-5 w-5" />,
    },
  ];

  const isActive = (path: string) => {
    if (path === "/admin" && currentPath === "/admin") return true;
    if (path !== "/admin" && currentPath.startsWith(path)) {
        const nextChar = currentPath.charAt(path.length);
        if(nextChar === '' || nextChar === '/' || nextChar === '?') {
             return true;
        }
    }
    return false;
  };

  return (
    <div className="w-64 bg-white border-r border-gray-200 min-h-screen">
      <div className="p-4 border-b border-gray-200">
        <Link to="/" className="flex items-center">
          <h1 className="text-xl font-bold text-navy-700">Alfa Peixes</h1>
          <span className="ml-2 text-xs bg-navy-100 text-navy-700 px-2 py-0.5 rounded-full">
            Admin
          </span>
        </Link>
      </div>
      <nav className="p-4 space-y-1">
        {navItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            className={`flex items-center px-4 py-3 text-sm font-medium rounded-md transition-colors ${
              isActive(item.href)
                ? "bg-navy-50 text-navy-700"
                : "text-gray-600 hover:bg-gray-50 hover:text-navy-700"
            }`}
          >
            <span className="mr-3">{item.icon}</span>
            {item.name}
          </Link>
        ))}
      </nav>
      <div className="p-4 border-t border-gray-200 mt-auto">
        <Link
          to="/"
          className="flex items-center px-4 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-gray-50 hover:text-gray-900"
        >
          <span className="mr-3">🏠</span>
          Voltar para a loja
        </Link>
      </div>
    </div>
  );
};

export default AdminSidebar;
